import { notification } from "antd";
export interface FileImageCoverProps {
  id: string;
  ext: string;
}

export const successNotification = () =>
  notification["success"]({
    message: "Creación Exitosa",
    description: "La lectoescritura fue creado con éxito!",
    placement: "top",
    duration: 3,
  });

export const errorNotification = () =>
  notification["error"]({
    message: "Error",
    description: "Se ha producido un error, vuelva a intentar!",
    placement: "top",
    duration: 3,
  });

export const updatedNotification = () =>
  notification["success"]({
    message: "Modificación Exitosa",
    description: "La lectoescritura fue modificado con éxito!",
    placement: "top",
    duration: 3,
  });
